export default "__VITE_ASSET__Dn36r2hM__"